module.exports = __webpack_public_path__ + "media/images/diy/light_lit_E-e01fea2db8ab57329690b65fc7b6f59c.png";